import {FC} from 'react'
import {Alert, Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {ENV} from '../../../../../../Utils/_helpers/EnvHelper'

export type ReviewContactProps = {
  error: string
  report: any
  isLoading: boolean
  handleNext: () => void
  handleCancel: () => void
}

const API_DOMAIN = ENV().REACT_APP_DOMAIN

const ReviewContact: FC<ReviewContactProps> = (props) => {
  const {report, error, isLoading, handleNext, handleCancel} = props
  return (
    <>
      <div className='modal-header'>
        <h2>Review Contact</h2>
      </div>
      <div className='modal-body report'>
        {error.length > 0 && (
          <Alert variant='danger'>
            <Alert.Heading>Error</Alert.Heading>
            <p>{error}</p>
          </Alert>
        )}
        <div
          className='card bg-secondary'
          style={{
            maxWidth: '100%',
          }}
        >
          <div className='card-body '>
            <div className='row'>
              <div className='col-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/communication\com005.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div className='summary_content'>
                  <span>
                    <strong>{report?.data?.data?.totalContact}</strong>
                  </span>
                  <p className='text-muted'>Total contacts in list</p>
                </div>
              </div>
              <div className='col-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen028.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div className='summary_content'>
                  <span>
                    <strong>{report?.data?.data?.uniqueContact}</strong>
                    <p className='text-muted'>Unique contacts in list</p>
                  </span>
                </div>
              </div>

              <div className='col-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen040.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div className='summary_content'>
                  <span>
                    <strong>{report?.data?.data?.duplicateContact}</strong>
                  </span>
                  <p className='text-muted'>Duplicate in list</p>
                </div>
              </div>
              <div className='col-6 summary_block'>
                <span className='bg-white p-2 me-2 rounded'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen044.svg'
                    className='svg-icon-2x mb-2'
                  />
                </span>
                <div className='summary_content'>
                  <span>
                    <strong>{report?.data?.data?.invalidContact}</strong>
                  </span>
                  <p className='text-muted'>Invalid Numbers</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='mt-5'>
          <p className='mb-0'>
            Review contact report.{' '}
            <a
              href={`${API_DOMAIN}/${report?.data?.data?.downloadUrl}`}
              style={{
                fontSize: 15,
              }}
            >
              Download report
            </a>
          </p>
        </div>
      </div>
      <div className='modal-footer w-100'>
        <>
          {' '}
          <button
            onClick={handleCancel}
            type='button'
            className='btn btn-light-primary'
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleNext}
            id='submit'
            type='button'
            className='btn btn-primary'
            disabled={isLoading}
          >
            {isLoading ? <Spinner size='sm' animation='grow' /> : 'Upload'}
          </button>
        </>
      </div>
    </>
  )
}

export default ReviewContact
